const pathlikeToPrintable = (s: string) => {
  return decodeURIComponent(
    s.split('-').map(e => `${e.charAt(0).toUpperCase()}${e.slice(1)}`).join(' ')
  ).replaceAll('$', '-');
};

export default pathlikeToPrintable;